

document.addEventListener("DOMContentLoaded", function() {
  // Get the button
  let mybutton = document.getElementById("scrollToTopBtn");

  // Get the header for sticky functionality
  var header = document.querySelector('.products-toolbar');
  var sticky = header.offsetTop;

  // When the user scrolls, handle both functionalities
  window.onscroll = function() {
    // Scroll to Top Button Visibility
    scrollFunction();

    // Sticky Header Functionality
    myFunction();
  };

  function scrollFunction() {
    if (document.body.scrollTop > 170 || document.documentElement.scrollTop > 170) {
      mybutton.style.display = "block";  // Show scroll to top button
    } else {
      mybutton.style.display = "none";   // Hide scroll to top button
    }
  }

  function myFunction() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");   // Add sticky class to header
    } else {
      header.classList.remove("sticky"); // Remove sticky class from header
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  mybutton.addEventListener("click", function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'  // Enable smooth scrolling
    });
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   // Check if the device is mobile (adjust the width condition as needed)
//   if (window.innerWidth <= 768) {  // Target screen width for mobile (you can adjust this value)
//       const popup = document.getElementById('delayedPopup');
//       const closeButton = document.getElementById('btnClose'); // Close (X) button
//       const popupBtn = document.querySelector('#delayedPopup .popup_btn'); // Explore button
//       const overlay = document.getElementById('bkgOverlay'); // Background overlay

//       // Check if the popup has been closed in this session
//       if (sessionStorage.getItem('popupClosed') === 'true') {
//           // If it has been closed, hide the popup and overlay immediately
//           popup.style.display = 'none';
//           overlay.style.display = 'none';
//       } else {
//           // Otherwise, set a timeout to display the popup after 4 seconds
//           setTimeout(function() {
//               popup.style.display = 'block';
//               overlay.style.display = 'block';
//               // Disable scrolling on body while the popup is open
//               document.body.style.overflow = 'hidden';
//           }, 4000); // 4000ms = 4 seconds
//       }

//       // Close button (X) click handler
//       closeButton.addEventListener('click', function(event) {
//           event.preventDefault(); // Prevent the default anchor behavior
//           popup.style.display = 'none'; // Hide the popup
//           overlay.style.display = 'none'; // Hide the background overlay
//           sessionStorage.setItem('popupClosed', 'true'); // Set sessionStorage flag to prevent showing the popup again
//           document.body.style.overflow = 'auto'; // Re-enable scrolling on body
//       });

//       // Explore button click handler (same as close button behavior)
//       popupBtn.addEventListener('click', function(event) {
//           event.preventDefault(); // Prevent the default anchor behavior
//           popup.style.display = 'none'; // Hide the popup
//           overlay.style.display = 'none'; // Hide the background overlay
//           sessionStorage.setItem('popupClosed', 'true'); // Set sessionStorage flag to prevent showing the popup again
//           document.body.style.overflow = 'auto'; // Re-enable scrolling on body
//       });
//   }
// });
//Product Slider
$('.product_slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
//Shop By Model Filter
$(document).ready(function() {
    // Set default image when page loads
    // var defaultImageSrc = $(".selectedImage").attr("src");
        var selectedOption = $(this).val().trim();
        var selectedImage = $(this).find("option:selected").attr("data-images");
        updateImage(selectedImage, selectedOption);
        // updateUrl(selectedOption);

   // var selectedOption = "";
   //      var selectedImage = "";
  
    function updateImage(src, alt) {
        $(".selectedImage").attr("src", src ).attr("alt", alt).show();
    }
    function updateUrl(selectedValue) {
        var params = new URLSearchParams(window.location.search);
        if (selectedValue) {
          params.delete('filter.p.tag');
          params.append('filter.p.tag', selectedValue);
        } else {
          params.delete('filter.p.tag');
        }
        // shop-by-model uses server-rendered sections (recommended products, FAQ)
        // that depend on the URL at page load — always do a hard navigation here
        // so those sections re-render correctly.
        var isDropdownNew = !!document.querySelector('.selectbox-wrapper.dropdown-new');
        if (isDropdownNew) {
          window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        } else if (typeof window.applyQuickFilter === 'function') {
          window.applyQuickFilter(params);
        } else {
          window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        }
    }
    // Event listener for change in select dropdown
    $("#tagfilter").on("change", function() {
        var selectedOption = $(this).val().trim();
        var selectedImage = $(this).find("option:selected").attr("data-images");
        // updateImage(selectedImage, selectedOption);
        updateUrl(selectedOption);
    });
    // Initial page load logic
    var tagUrl = new URLSearchParams(window.location.search).get("filter.p.tag");
    if (tagUrl) {
        tagUrl = tagUrl.replace(/\+/g, " ").toUpperCase().trim();
        $(".coll-filter option").each(function() {
            var val = $(this).val();
            var imgSrc = $(this).attr("data-images");
            if (val) {
                var optValue = val.toUpperCase().trim();
                if (tagUrl === optValue) { // Direct comparison with tagUrl
            
                    $(".coll-filter").val(val);
                    updateImage(imgSrc, val);
                    return false; // Break the loop
                }
            }
        });
    }
});

//To Disbale Gokwick Button When variant is sold out
document.addEventListener('DOMContentLoaded', function() {
  var addToCartButton = document.querySelector('.addToCart-ga4');
  var gokwikCheckout = document.querySelector('.gokwik-checkout');
  function updateGokwikCheckoutState() {
    if (addToCartButton.disabled) {
      gokwikCheckout.style.opacity = '0.4';
      gokwikCheckout.classList.add('disabled-checkout');
    } else {
      gokwikCheckout.style.opacity = '1';
      gokwikCheckout.classList.remove('disabled-checkout');
    }
  }
  // Initially update the state based on the current button status
  updateGokwikCheckoutState();
  // Listen for changes to the Add to Cart button state
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'disabled') {
        updateGokwikCheckoutState();
      }
    });
  });
  observer.observe(addToCartButton, { attributes: true });
});

// on scroll plp filter display none
let scrollTimer;
const toolbar = document.querySelector('.products-toolbar');

// Classes that should disable the scroll-hide script
const blockedClasses = ['collection-Shop', 'By', 'Model'];

const body = document.body;

// Check if ANY blocked class exists on the body
const shouldStop =
  blockedClasses.some(cls => body.classList.contains(cls));

if (!shouldStop && toolbar) {
  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 768) {

      // Hide immediately while scrolling
      toolbar.style.display = 'none';

      // Reset previous timer
      clearTimeout(scrollTimer);

      // Show again after 5 seconds of no scrolling
      scrollTimer = setTimeout(() => {
        toolbar.style.display = 'flex';
      }, 500); // 5 seconds
    }
  });
}


